import React, { Component } from 'react'

import './floating-action.styl'

export default class FloatingAction extends Component {
  render() {
    return (
      <div className="floating-action">
        <div className="floating-action__wrapper">{this.props.children}</div>
      </div>
    )
  }
}
